import { useDispatch } from "react-redux";
import { ActivateViewFilterAction, DeactivateViewFilterAction } from "../../../../store/analytics/Analytics";
import { useState } from "react";

export interface NumericFilterProps {
    viewId: string;
    filterId: string;
    maximum: number;
}

function NumericFilter(props: NumericFilterProps) {
    const dispatch = useDispatch();
    const [sliderValue, setSliderValue] = useState(0);

    function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = parseFloat(e.target.value);
        setSliderValue(value);

        if (!isNaN(value) && value > 0) {
            dispatch({
                type: "analytics/activateViewFilter",
                payload: { viewId: props.viewId, filterId: props.filterId, parameter: { minimum: value } },
            } as ActivateViewFilterAction);
        } else {
            dispatch({
                type: "analytics/deactivateViewFilter",
                payload: { viewId: props.viewId, filterId: props.filterId },
            } as DeactivateViewFilterAction);
        }
    }

    return (
        <div>
            <input
                type="range"
                step={props.maximum / 20}
                max={props.maximum}
                onChange={handleOnChange}
                defaultValue="0"
            />
            <div className="numeric-value text-muted">Showing from {sliderValue.toFixed(2)}</div>
        </div>
    );
}

export default NumericFilter;
